<div *ngIf="prikaziStranicu" class="container-fluid">
  <div class="content-block">
    <h2>Strojevi na liniji</h2>

    <p *ngIf="!linijeDohvacene">{{ linijeDohvacenePoruka }}</p>
    <div class="selectControl" *ngIf="linijeDohvacene">
      <label>Linija:</label>
      <dx-select-box
        [disabled]="pravaZaTrenutniPogled != 2"
        [dataSource]="sveLinije"
        displayExpr="naziv"
        valueExpr="id"
        (onValueChanged)="odaberiLiniju($event)"
        placeholder="Odaberi liniju"
        [searchEnabled]="true"
        [searchExpr]="['id', 'naziv']"
        width="400"
      >
      </dx-select-box>
    </div>

    <div class="selectControl" *ngIf="odabranaLinija">
      <label>Proces:</label>
      <dx-select-box
        [disabled]="pravaZaTrenutniPogled != 2"
        [dataSource]="sviProcesi"
        displayExpr="naziv"
        valueExpr="id"
        (onValueChanged)="odaberiProces($event)"
        placeholder="Odaberi proces"
        [searchEnabled]="true"
        [searchExpr]="['naziv']"
        width="400"
      >
      </dx-select-box>
    </div>

    <div class="selectControl" *ngIf="odabranaLinija && odabraniProces">
      <label>Dodaj stroj na liniju:</label>
      <dx-select-box
        [disabled]="pravaZaTrenutniPogled != 2"
        #selectBox
        [dataSource]="sviStrojevi"
        displayExpr="sifraNaziv"
        valueExpr="id"
        (onValueChanged)="odaberiStroj($event)"
        placeholder="Odaberi stroj"
        [searchEnabled]="true"
        [searchExpr]="['id', 'sifra', 'naziv']"
        width="400"
        [showClearButton]="true"
      >
      </dx-select-box>
    </div>

    <div class="customTable" *ngIf="odabranaLinija">
      <dx-data-grid
        [disabled]="pravaZaTrenutniPogled != 2"
        class="my-40"
        [dataSource]="procesi"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        keyExpr="id"
        [columnAutoWidth]="true"
        (onRowUpdated)="spremiPromjene($event)"
        (onRowRemoved)="obrisiStrojSaLinije($event)"
      >
        <dxo-editing
          mode="batch"
          [allowUpdating]="true"
          [allowDeleting]="true"
          [selectTextOnEditStart]="true"
          [startEditAction]="'click'"
        >
        </dxo-editing>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>

        <dxi-column
          cellTemplate="aktivan"
          [width]="60"
          [fixed]="true"
          fixedPosition="left"
        >
          <div *dxTemplate="let data of 'aktivan'">
            <dx-button
              icon="{{ data.data.aktivan ? 'isnotblank' : 'isblank' }}"
              (onClick)="oznaciProces(data)"
            ></dx-button>
          </div>
        </dxi-column>
        <dxi-column
          dataField="aktivan"
          caption=""
          [visible]="false"
        ></dxi-column>
        <dxi-column
          dataField="sifraNaziv"
          caption="Naziv stroja"
          [allowEditing]="false"
          [width]="280"
          [fixed]="true"
          fixedPosition="left"
        ></dxi-column>
        <dxi-column
          dataField="amortizacija"
          caption="Amortizacija po minuti"
          alignment="center"
          [minWidth]="130"
        ></dxi-column>
        <dxi-column
          dataField="potrosnjaStruje"
          caption="Potrošnja struje na stroju KW/m"
          alignment="center"
          [minWidth]="130"
        ></dxi-column>
        <!-- <dxi-column
        dataField="struja"
        caption="Struja - stroj"
        alignment="center"
        [minWidth]="130"
      ></dxi-column> -->
        <dxi-column
          dataField="potrosnjaPlina"
          caption="Potrošnja plina na stroju m3"
          alignment="center"
          [minWidth]="130"
        ></dxi-column>
        <!-- <dxi-column
        dataField="plin"
        caption="Plin - stroj"
        alignment="center"
        [minWidth]="130"
      ></dxi-column> -->
        <dxi-column
          dataField="potrosnjaVode"
          caption="Potrošnja vode na stroju m3"
          alignment="center"
          [minWidth]="130"
        ></dxi-column>
        <!-- <dxi-column
        dataField="voda"
        caption="Voda - stroj"
        alignment="center"
        [minWidth]="130"
      ></dxi-column> -->
        <!-- <dxi-column
        dataField="ulaznaFaktura"
        caption="Ulazna faktura"
        alignment="center"
        [minWidth]="130"
      ></dxi-column> -->
        <dxi-column
          dataField="idProces"
          caption="Povezano sa procesom"
          [minWidth]="200"
          alignment="left"
        >
          <dxo-lookup
            [dataSource]="procesiLookup"
            valueExpr="id"
            displayExpr="naziv"
          >
          </dxo-lookup>
        </dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
